export default "__VITE_ASSET__zUmFl6D0__"